import {
  Link as UiLink,
  type LinkProps as UiLinkProps,
} from '@veraclins-dev/ui';
import { cn } from '@veraclins-dev/utils';
import {
  NavLink as RouterNavLink,
  type NavLinkProps as RouterNavLinkProps,
} from 'react-router';

export type AppNavLinkProps = Omit<
  UiLinkProps<typeof RouterNavLink>,
  'component'
> &
  Pick<RouterNavLinkProps, 'end' | 'caseSensitive'>;

export function AppNavLink({
  className,
  type = 'link',
  underline = 'none',
  ...props
}: AppNavLinkProps) {
  return (
    <UiLink
      component={RouterNavLink}
      type={type}
      underline={underline}
      {...props}
      className={cn('aria-[current=page]:text-primary', className)}
    />
  );
}
